/**
 * @file danger-status.icon.tsx
 * @description Компонент для отображения иконки важных сообщений.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

export const WarningStatusIcon = ({ color = '#FFA51E', size = '1.9054vmin' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.12842 1.54947C8.51073 0.869818 9.48927 0.869816 9.87158 1.54947L17.1617 14.5097C17.5367 15.1763 17.055 16 16.2902 16H1.70985C0.94502 16 0.463307 15.1763 0.838272 14.5097L8.12842 1.54947Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 6C9.55228 6 10 6.3731 10 6.83333V10.1667C10 10.6269 9.55228 11 9 11C8.44772 11 8 10.6269 8 10.1667V6.83333C8 6.3731 8.44772 6 9 6Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 12C9.55228 12 10 12.4477 10 13C10 13.5523 9.55228 14 9 14C8.44772 14 8 13.5523 8 13C8 12.4477 8.44772 12 9 12Z"
                fill="white"
            />
        </svg>
    );
};
